import { useUser } from '@hooks/queries/useUser';
import { UserHelper } from '@models/User';

export const useUserHelper = () => {
  const query = useUser();

  return {
    ...query,
    data: query.data ? new UserHelper(query.data) : undefined,
  };
};
